import getUncompletedSections from './getUncompletedSections';
import {DemandValidation} from "../constants/DemandValidation";
import {PublishConst} from "../constants/PublicationConst";
import {isDemandModification, isDemandPreparing} from "./getDemandStatus";
import {DemandValidationSectionStatus} from "../constants/DemandValidationSectionStatus";
import NationalNoticeStatus from "../components/complex/nationalNotice/constants/NationalNoticeStatus";

export default (demandValidation, ojsPublicationStatus, bzpContractNoticeStatus, isDemandChanged) => {
    if (!demandValidation) return false;
    if (!(isDemandPreparing() || (isDemandModification() && isDemandChanged && isDemandChanged.result))) {
        return false;
    }

    const uncompleted = getUncompletedSections(demandValidation);
    const hasUncompletedSections = uncompleted.length > 0;
    if (hasUncompletedSections) {
        return false;
    }

    const notice = demandValidation.find((x) => x.section === DemandValidation.NOTICE);
    const isNoticeAvailable = notice ? notice.status !== DemandValidationSectionStatus.UNAVAILABLE : false;
    if (isNoticeAvailable) {
        if (ojsPublicationStatus && (ojsPublicationStatus.status === PublishConst.PUBLISHED || ojsPublicationStatus.status === PublishConst.CONFIRMED || ojsPublicationStatus.status === PublishConst.UNAVAILABLE)) {
            return true;
        } else {
            return false;
        }
    }

    const nationalNotice = demandValidation.find((x) => x.section === DemandValidation.NATIONAL_NOTICE);
    const isNationalNoticeAvailable = nationalNotice ? nationalNotice.status !== 'UNAVAILABLE' : false;
    if (isNationalNoticeAvailable) {
        if (bzpContractNoticeStatus && (bzpContractNoticeStatus.status === NationalNoticeStatus.PUBLISHED || bzpContractNoticeStatus.status === NationalNoticeStatus.NONE)) {
            return true;
        } else {
            return false;
        }
    }


    return true;
}
